import React, {createContext, useContext, useState} from 'react';

const StateContext = createContext();

const initialState = {
    userProfile: false,
}

export const ContextProvider = ({children}) => {

    const [activeMenu, setActiveMenu] = useState (true);
    const [isClicked, setIsClicked] = useState (initialState);
    const [screenSize, setScreenSize] = useState(undefined);
    const [installPromptEvent, setInstallPromptEvent] = useState(null);
    const [isLogged, setIsLogged] = useState(!!localStorage.getItem('jwt'));
    const [searchTerm, setSearchTerm] = useState('');  // Add search term state
    const [currentPage, setCurrentPage] = useState(1);
    const[ filteredData, setFilteredData] = useState([]); 


    

    const handleClick = (clicked) => {
        setIsClicked({
            ...initialState, [clicked] : true
        });
    }

    

    return (
        <StateContext.Provider value = {{
            activeMenu,
            setActiveMenu,
            isClicked,
            setIsClicked,
            handleClick,
            screenSize,
            setScreenSize,
            installPromptEvent,
            setInstallPromptEvent,
            isLogged,
            setIsLogged,
            searchTerm,  
            setSearchTerm,
            currentPage,
            setCurrentPage,
            filteredData,
            setFilteredData,
            }}
        >

        {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext);